import moment from 'moment';
import React from 'react';

const MessageSentDate = incDate => {
  if (!incDate) return null;

  const date = moment(incDate, 'YYYYMMDD').format('MMMM DD, YYYY');
  return (
    <cite key={`date${date}`}>
      <div
        key={`date${date}`}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '11px',
          color: '#9C9C9C',
          paddingBlock: '16px',
          fontStyle: 'normal',
          fontWeight: 500,
          letterSpacing: '0.3px',
        }}
      >
        <span>{date}</span>
      </div>
    </cite>
  );
};

export default MessageSentDate;
